// Copyright (c) 2017 Deere & Company

import {
    getElementOffsetHeight,
    getWindowHeight,
    resizeReportGrid
} from '../../../reports/shared/services/window-helpers';

export const resizeReport = () => {

    const windowHeight = getWindowHeight();
    const appHeaderHeight = getElementOffsetHeight('app-header');
    const breadCrumbsHeight = getElementOffsetHeight('bread-crumbs');
    const summaryHeaderHeight = getElementOffsetHeight('reimbursement-summary-header');
    const detailPanelHeight = getElementOffsetHeight('detail-panel');

    resizeReportGrid(windowHeight - appHeaderHeight - breadCrumbsHeight - summaryHeaderHeight - detailPanelHeight - 50);

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/shared/services/resize-report.js